<template>
  <v-container>
    <v-row 
      v-if="!expertId"
      align="center"
    >
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="auto">
        <v-text-field
          v-model="keyword"
          filled
          dense
          flat
          solo
          clearable
          label="Tìm câu hỏi"
          placeholder="Vd: làm thế nào ..."
          prepend-inner-icon="mdi-magnify" 
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row 
      v-if="!expertId"
      align="center" 
    >
      <v-col cols="12">
        <v-slide-group
          active-class="success"
          show-arrows
        >
          <template v-slot:next>
            <v-btn icon>
              <v-icon large>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
          <template v-slot:prev>
            <v-btn icon>
              <v-icon large>mdi-chevron-left</v-icon>
            </v-btn>
          </template>
          <v-slide-item
            v-for="(support, n) in supports"
            :key="n"
          >
            <v-hover v-slot="{ hover }">
              <v-card flat 
                width="300" 
                height="100%"
                :color="!hover ? 'rgb(255, 0, 0, 0)' : 'teal lighten-1 rounded-bl-xl rounded-tr-xl'"
                :to="{ name: 'ExpertView', params: { id: support.id }}"
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-subtitle 
                      v-html="support.branch.name" 
                      class="mb-2" 
                      :class="{'white--text': hover, 'primary--text': !hover}"
                    />
                    <v-list-item-title class="headline no-break-w" :class="{'white--text': hover}">
                      {{support.tengoi}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-hover>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="typeSelected"
          :items="types"
          item-text="name"
          item-value="id"
          label="Lọc theo lĩnh vực"
          prepend-inner-icon="mdi-filter"
          multiple
          filled
          dense
          flat
          solo
          clearable
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="statusSelected"
          :items="status"
          filled
          dense
          flat
          solo
          clearable
          label="Lọc theo tình trạng"
          prepend-inner-icon="mdi-filter"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="sortSelected"
          :items="sorts"
          filled
          dense
          flat
          solo
          clearable
          label="Sắp xếp theo"
          prepend-inner-icon="mdi-sort-alphabetical-variant"
          hide-details
          v-on:change="searchItems"
        />
      </v-col>
    </v-row>
    <h4 class="text-right mb-4 font-weight-light">
      Trang {{currentPage}} (Tổng {{totalPages}} Trang, {{totalItems}} mục)
    </h4>
    <h4 class="text-center mb-4 font-weight-light" v-if="!$store.state.loader && items.length==0">
      Không tìm thấy! Thử điều chỉnh lại các bộ lọc
    </h4>
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="3"
        v-for="item in items" 
        :key="item.id"
      >
        <v-sheet height="100%" class="rounded-lg overflow-hidden">
          <v-hover v-slot="{ hover }">
            <v-card flat>
              <router-link
                :to="{ name: 'SupportView', params: { id: item.id }}"
              >
                <v-img
                  src="@/assets/hoi-dap-nong-nghiep.jpg"
                  :class="hover ? 'zoom' : ''"
                  :aspect-ratio="16/9"
                >
                  <div class="qas-tag">
                    <v-icon color="white">
                      mdi-tag-outline
                    </v-icon>
                    {{item.branch.name}}
                  </div>
                </v-img>
              </router-link>
              <v-card-subtitle class="py-2">
                <v-icon>mdi-clock</v-icon>
                {{item.created_at_text}}
                <span class="px-1"/>
                <v-icon v-if="item.traloi" color="primary">mdi-checkbox-marked-circle-outline</v-icon>
                <v-icon v-else color="orange">mdi-clock-time-four-outline</v-icon>
                <span class="ml-1">{{ item.traloi ? 'Đã trả lời' : 'Đang chờ' }}</span>
                <span class="px-1"/>
                <v-icon>mdi-eye</v-icon>
                {{item.countview}}
              </v-card-subtitle>
              <v-card-title class="pt-0 pb-4">
                <div class="text-body-1 font-weight-medium">
                  {{item.tieude}}
                </div>
              </v-card-title>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import { mapGetters, mapActions } from 'vuex';
  export default {
    props: {
      filter: {
        type: Boolean,
        default: true
      },
      expertId: {
        type: Number
      },
    },
    components: { 
      BaseBreadcrumbs
    },
    data: () => ({
      search: {
        keyword: '',
        type: ''
      },
      loading: false,
      crumbs: [],
      items: [],
      currentPage: 1,
      totalItems: 0,
      totalPages: 0,
      types: [],
      typeSelected: null,
      selectedOrderItem: null,
      orders:[
        {
          action: 'mdi-order-alphabetical-ascending', 
          value: 'tieude', 
          text: 'Tiêu đề'
        },
        {
          action: 'mdi-order-numeric-ascending', 
          value: 'created_at', 
          text: 'Ngày đăng'
        }
      ],
      sorts: ['A-Z', 'Z-A'],
      sortSelected: null,
      status: ['Đang chờ', 'Đã trả lời'],
      statusSelected: null,
      debouncedInput: '',
      timeout: null,
      supports: []
    }),
    computed: {
      ...mapGetters([
        'isLogged'
      ]),
      keyword: {
        get() {
          return this.keywordInput;
        },
        set(val) {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.keywordInput = val;
            this.initialize();
          }, 1000);
        }
      }
    },
    watch: {
      expertId() {
        this.initialize();
      }
    },
    mounted () {
      this.initialize();
      this.getTypes();
      this.getExperts();
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Hỏi đáp kỹ thuật',
          disabled: true
        }
      ];
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      getRequestParams(page) {
        let params = {};

        params["visible"] = 1;

        if (page) {
          params["page"] = page;
        }

        if(this.typeSelected){
          params["type"] = this.typeSelected;
        }

        if(this.sortSelected){
          params["sort"] = this.sortSelected;
        }

        if(this.keywordInput){
          params["keyword"] = this.keywordInput;
        }

        if(this.statusSelected){
          params["status"] = this.statusSelected;
        }

        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.initialize();
        this.$vuetify.goTo(0);
      },
      initialize () {
        const app = this;
        const params = app.getRequestParams(
          app.currentPage,
        );
        if(app.expertId){
          params["expertId"] = app.expertId;
        }
        app.getLoader(true);
        let request = {
          params: params
        };
        axios.get("api/v1/public/supports", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            app.totalPages = Math.ceil(caluTotalPage);
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      searchItems(){
        this.initialize();
      },
      getTypes () {
        axios.get("api/v1/public/branchs")
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getExperts () {
        this.loading = true;
        axios.get("api/v1/public/experts")
          .then(response => {
            this.supports = response.data;
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>
<style>
  .qas-tag{
    background: rgb(0 0 0 / 50%);
    padding: 10px;
    color: #fff;
  }
</style>
